import React from 'react';
import { Trans } from '@lingui/macro';
import { Button } from '@economic/taco';
import { Plan, useCurrentAgreement, useCurrentUser } from '@economic/react-app';

import useQuery from '~/app/shared/hooks/useQuery';
import EditCompanyInfoDialog from '~/app/pages/settings/master-information/dialogs/EditCompanyInfoDialog';
import { isCvrReadonly } from '~/app/pages/settings/master-information/sections/CompanyInfo';
import { useSignupDialogOnboardingContext } from '../../../contexts/SignupDialogOnboardingContextProvider';

const EditCompanyInfoDialogButton = () => {
    const { number: agreementNumber, subscription, cvr } = useCurrentAgreement();
    const user = useCurrentUser();
    const { companyData, refetchCompanyData } = useSignupDialogOnboardingContext();

    const isAdministrator = user.isAdministrator && agreementNumber === user.agreement.number;
    const isInternalAgreement = subscription.level === Plan.Internal;
    const adminInfoQuery = useQuery<any>('/administrator/getCurrentAdministratorOffice', {}, { skip: !isAdministrator });

    const company = isAdministrator ? adminInfoQuery?.data?.model : companyData?.model;

    if (!company) return null;

    return (
        <Button
            appearance="discrete"
            dialog={dialogProps => (
                <EditCompanyInfoDialog
                    {...dialogProps}
                    initialData={company}
                    onSubmitted={refetchCompanyData}
                    isAdministrator={isAdministrator}
                    isCvrReadonly={isCvrReadonly(company, cvr, subscription)}
                    isInternalAgreement={isInternalAgreement}
                    isAdministratorPayingForCurrentAgreement={companyData?.isAdministratorPayingForCurrentAgreement}
                    enforce2FAReason={companyData?.enforce2FAReason}
                    shouldDisable2FA={companyData?.shouldDisable2FA}
                />
            )}>
            <Trans>Update master information</Trans>
        </Button>
    );
};

export default EditCompanyInfoDialogButton;
